export const STORAGE_MODE_OVERRIDE = String(
  import.meta.env?.VITE_STORAGE_MODE || ""
)
  .trim()
  .toLowerCase();

const LOCAL_PERSISTENCE_DISABLED_ENV = String(
  import.meta.env?.VITE_DISABLE_LOCAL_STORAGE_PERSISTENCE || ""
)
  .trim()
  .toLowerCase();

export function getStorageModeOverride() {
  if (STORAGE_MODE_OVERRIDE === "local") return "local";
  if (STORAGE_MODE_OVERRIDE === "cloud") return "cloud";
  return null;
}

export function isLocalStoragePersistenceDisabled() {
  if (LOCAL_PERSISTENCE_DISABLED_ENV === "true") return true;
  if (typeof window === "undefined") return false;
  try {
    const flag = String(window.localStorage.getItem("disable_local_storage_persistence") || "")
      .trim()
      .toLowerCase();
    return flag === "1" || flag === "true" || flag === "yes";
  } catch {
    return false;
  }
}
